import axios from '../../axios';

export default {
  namespaced: true,
  state: {
    allModuleTypes: [
      { id: 1, type: 'Html', tag: 'app-module-html' },
      { id: 2, type: 'SlideShow', tag: 'app-module-slideshow' },
      { id: 3, type: 'CuratedPageList', tag: 'app-curated-page-list' },
    ],
    currentModules: null,
  },
  getters: {
    getCurrentModules: (state) => {
      if (state.currentModules) {
        return state.currentModules;
      }
    },
    getCurrentModulesByAreaId: (state) => (areaId) => {
      if (state.currentModules) {
        return state.currentModules
          .filter((o) => o.templateAreaId === areaId)
          .sort((a, b) => ((a.sortOrder > b.sortOrder) ? 1 : ((b.sortOrder > a.sortOrder) ? -1 : 0)));
      }
    },
  },
  mutations: {
    setCurrentModules(state, modules) {
      state.currentModules = modules;
    },
  },
  actions: {
    fetchModulesByPath({
      commit, state, dispatch, getters,
    }, path) {
      return new Promise((resolve, reject) => {
        state.currentModules = null;
        let odata = '$select=modules';
        odata += '&$expand=modules($select=moduleTypeId,templateAreaId;$expand=moduleSettings($select=name,value))';
        axios.get(`/cms/pages/modules/bypath?path=${(path !== '/' ? path : '')}&${odata}`)
          .then((res) => {
            commit('setCurrentModules', res.data.modules);
            resolve(res.data);
          });
      });
    },
  },
};
